export default "__VITE_ASSET__yckkPZWA__"